import React from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { DCard } from './MarketplaceAtoms.js';
import {
  MARKETPLACE_SLA,
  slaOrderStepHint,
  businessDaysLabel,
} from '../constants/marketplaceSla.js';

const STORE_ITEMS = [
  { label: 'El vendedor entrega el disco en tu tienda', sla: MARKETPLACE_SLA.sellerToPartner },
  { label: 'Verificación y preparación en tienda', sla: MARKETPLACE_SLA.partnerStoreVerification },
  { label: 'Envío al comprador (si eligió envío a domicilio)', sla: MARKETPLACE_SLA.partnerOutboundToBuyer },
];

const PICKUP_ITEMS = [
  { label: 'El vendedor entrega el paquete en tu punto', sla: MARKETPLACE_SLA.sellerToPartner },
  { label: 'Recepción y validación en punto', sla: MARKETPLACE_SLA.partnerPickupReceive },
  { label: 'Envío al comprador (si eligió envío a domicilio)', sla: MARKETPLACE_SLA.partnerOutboundToBuyer },
];

/**
 * Aviso de plazos orientativos para partners (mismo criterio que PagePedido y Términos §5.1).
 * @param {'store'|'pickup'} role
 */
export default function PartnerSlaBanner({ role = 'store' }) {
  const items = role === 'pickup' ? PICKUP_ITEMS : STORE_ITEMS;
  const hint = slaOrderStepHint(MARKETPLACE_SLA.sellerToPartner);

  return (
    <DCard
      style={{
        padding: '12px 14px',
        marginBottom: 16,
        background: 'rgba(200,168,75,0.06)',
        borderColor: 'rgba(200,168,75,0.25)',
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 700, color: C.gold, marginBottom: 6 }}>Plazos orientativos</div>
      <p style={{ margin: '0 0 10px', fontSize: 11, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5 }}>
        Mismo criterio que ve el comprador en el detalle del pedido. Debes cumplir estos máximos en días laborables (lunes a
        viernes; sin festivos).
      </p>
      <ul
        style={{
          margin: '0 0 10px',
          paddingLeft: 18,
          fontSize: 11,
          color: 'rgba(255,255,255,0.75)',
          lineHeight: 1.55,
        }}
      >
        {items.map(item => (
          <li key={item.label} style={{ marginBottom: 4 }}>
            <span style={{ color: 'rgba(255,255,255,0.88)' }}>{item.label}:</span>{' '}
            <span style={{ color: C.gold }}>{businessDaysLabel(item.sla)}</span>
          </li>
        ))}
      </ul>
      <div
        style={{
          fontSize: 10,
          color: 'rgba(255,255,255,0.45)',
          lineHeight: 1.45,
          padding: '8px 10px',
          borderRadius: 8,
          background: 'rgba(0,0,0,0.2)',
          border: '0.5px solid rgba(255,255,255,0.08)',
        }}
      >
        {hint}
      </div>
    </DCard>
  );
}
